// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"lock-off"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4.5 10H19.5V21H4.5V10Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M7 11L6.99999 7C6.99999 4.23858 9.23857 2 12 2C14.2388 2 16.134 3.47145 16.7711 5.5M4.5 11H19.5V21H4.5V11Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10 16H14","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-lock-off')
export default class LockOffIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'lock-off',
    }
  }
}
